module.exports = __webpack_public_path__ + "img/1280.7c5b0d81.svg";